function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "0460FF20-FA54-45E2-A9A2-0967C05B1244");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Notifications",
  transform: "translate(-34.000000, -181.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "left-rail-collapsed",
  transform: "translate(-1.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tractor",
  transform: "translate(35.000000, 182.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.137931, 0.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.862068966,
  y1: 19.3103448,
  x2: 3.62068966,
  y2: 8.27586207,
  id: "Line-2",
  stroke: "#000000",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0344828,8.27586207 L16.0342667,8.9180942 C14.7730629,10.1912715 13.9655172,12.0508688 13.9655172,13.7931034 C13.9655172,14.6865216 14.1778726,15.6441517 14.5548624,16.5515335 L10.5172414,16.5517241 L10.5172414,16.5517241 C10.5172414,15.02818 9.28216483,13.7931034 7.75862069,13.7931034 L7.75862069,9.79489126 L9.31034483,8.27586207 L16.0344828,8.27586207 Z",
  id: "Combined-Shape-Copy-3",
  stroke: "#000000",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-31",
  stroke: "#000000",
  strokeWidth: 1.5,
  cx: 7.75862069,
  cy: 16.8965517,
  r: 2.75862069
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-32",
  fill: "#000000",
  cx: 7.75862069,
  cy: 16.8965517,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.5517241,3.10344828 L21.5517665,9.02175305 C20.9128368,8.76311467 20.2144303,8.62068966 19.4827586,8.62068966 C18.5137895,8.62068966 17.6031617,8.87047888 16.8117555,9.30917724 L16.0344828,9.31034483 L16.0344828,4.33677936 L17.4137931,3.10344828 L21.5517241,3.10344828 Z",
  id: "Combined-Shape",
  stroke: "#000000",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-33",
  stroke: "#000000",
  strokeWidth: 1.5,
  cx: 19.4827586,
  cy: 14.137931,
  r: 5.51724138
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-34",
  stroke: "#000000",
  strokeWidth: 1.5,
  cx: 19.4827586,
  cy: 14.137931,
  r: 1.37931034
}), /*#__PURE__*/React.createElement("line", {
  x1: 16.0344828,
  y1: 0.344827586,
  x2: 22.9310345,
  y2: 0.344827586,
  id: "Line-3-Copy-10",
  stroke: "#000000",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}))))));

var SvgTractorBlack = function SvgTractorBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 26 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTractorBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tractor-black.b1eaf479.svg";
export { ForwardRef as ReactComponent };